import ContatosProvider from '../contexts/ContatosContexto';
import AgendamentoAlteracaoProvider from '../pages/Demanda/Contextos/AgendamentoAlteracaoContexto';

export const Provedores = [AgendamentoAlteracaoProvider, ContatosProvider];
